import { Component, Input } from '@angular/core';
import { NgIf } from "@angular/common";
import { Prompt } from "@models/prompt.model";
import { AiAssistantStore } from "@store/component/ai-assistant.store";

@Component({
    selector: 'lex-prompt-item',
    imports: [
        NgIf
    ],
    templateUrl: './prompt-item.component.html',
    styleUrl: './prompt-item.component.scss'
})
export class PromptItemComponent {
	@Input() prompt: Prompt;
	@Input() isHovering: boolean;
	@Input() canDelete: boolean;
	constructor(private aiAssistantStore: AiAssistantStore) {
	}
	public deletePrompt($event: MouseEvent, promptId: string) {
		$event.stopPropagation();
		this.aiAssistantStore.deletePrompt(promptId);
	}
}
